import { makeCreateAction } from 'web-app/util/redux/action-helpers';
import { getStore } from 'signin-app/redux/store';
import ENV from 'signin-app/config/environment';
export const lazyDispatch = (action) => {
    getStore().dispatch(action);
};
export const createAction = makeCreateAction(lazyDispatch, ENV.isDevelopment);
